import {createSelector} from 'reselect';
import _values from 'lodash/values';


export const getLang = createSelector(
  (state, params = {}) => {
    const {lang} = state.ui;
    return lang;
  },
  lang => lang,
)

export const getUsers = createSelector(
  (state, params = {}) => {
    const {users} = state;
    const asArray = _values(users);
    return asArray;
  },
  users => users,
)



// WEBPACK FOOTER //
// ./src/selectors.js